import { ixMap } from './helpers.js';
import { pipe, map,  splitEvery } from 'ramda';
import { generate } from 'shortid';


// https://github.com/clux/roundrobin/blob/master/robin.js
// generate schedule for POINTS table competition type
const DUMMY = -1;

const getRobinedIds = (n, ps) => {  // n = num players
  var rs = [];                  // rs = round array
  if (!ps) {
    ps = [];
    for (var k = 1; k <= n; k += 1) {
      ps.push(k);
    }
  } else {
    ps = ps.slice();
  }

  if (n % 2 === 1) {
    ps.push(DUMMY); // so we can match algorithm for even numbers
    n += 1;
  }
  for (var j = 0; j < n - 1; j += 1) {
    rs[j] = []; // create inner match array for round j
    for (var i = 0; i < n / 2; i += 1) {
      if (ps[i] !== DUMMY && ps[n - 1 - i] !== DUMMY) {
        rs[j].push([ps[i], ps[n - 1 - i]]); // insert pair as a match
      }
    }
    ps.splice(1, 0, ps.pop()); // permutate for next round
  }
  return rs;
};

// TODO peaks esimesena eelistama perfektselt jagunevaid gruppe!
const getGroupSize = (teamSize, min, groupSize) => {
  const m = teamSize % groupSize;

  return m === 0 || m >= min ? groupSize : getGroupSize(teamSize, min, groupSize - 1);
};

export const getRRT = (teams, competition, beginTimeInSeconds) => {
  const {
    rrtCompetitorsInGroupMax: max,
    rrtCompetitorsInGroupMin: min,
    rrtConcurrentGroupGames: concurrentGames,
    rrtConcurrentGroups: concurrentGroups,
    //rrtCompetitorsInGroupAdvancing: advancing,
    attemptMaxLengthInSeconds: l
  } = competition;

  const groupSize = getGroupSize(teams.length, min, max);

  let matches = [],
      groupIx = 0,
      roundIx = 0,
      groupBeginTime,
      matchBeginTime,
      lastMatchEndTime,
      concurrentMatchCounter;
  
  pipe(
    //map(prop('teamId')),
    // split teams to groups of predefined groupSize
    splitEvery(groupSize),
    // implement RoundRobin on each group
    map(teamsInGroup => getRobinedIds(teamsInGroup.length, teamsInGroup)),
    // split groups into concurrent groups
    // e.g. groups where matches take place at the same time
    splitEvery(concurrentGroups),
    // iterate over groups that play after one another 
    ixMap((timeGroup, timeGroupIx, timeGroups) => {
      //console.log('TG:' + timeGroupIx);
      // new timeGroup. Increment the beginning time of group
      groupBeginTime = lastMatchEndTime ? lastMatchEndTime : beginTimeInSeconds;

      
      map(group => {
        matchBeginTime = groupBeginTime;
        // reset concurrent match counter
        concurrentMatchCounter = 0;
        
        // console.log('G:' + groupIx);
        // console.log('GbTime:' + groupBeginTime);

        map(round => {
          //console.log('R:' + roundIx);

          map(match => {
            const matchId = generate();

            // console.log(groupIx + '/' +
            //             roundIx + '/' +
            //             concurrentMatchCounter + '/' +
            //             matchBeginTime + '/');

            lastMatchEndTime = matchBeginTime + l;
            
            map(team => {
              matches.push({
                matchId: matchId,
                group: groupIx + 1,
                attempt: roundIx + 1,
                team: team,
                beginTime: matchBeginTime,
                endTime: lastMatchEndTime
              });
            }, match);


            if (concurrentGames > 1 && concurrentMatchCounter < (concurrentGames -1)) {
              concurrentMatchCounter += 1;
            } else {
              matchBeginTime += l;
              concurrentMatchCounter = 0;
            }

          }, round);

          roundIx += 1;
        }, group);
        
        groupIx +=1;
        roundIx = 0;
      }, timeGroup);
    })
  )(teams);

  return matches;
};



// WEBPACK FOOTER //
// ./src/private/admin/utils/scheduler/round_robin.js